module.exports = "<main id=\"error\">\n  <section>\n    <article>\n      <p><p translate>download.message</p>\n      <br /><br />\n      <p><a [href]=\"url\" class=\"button button-primary\">{{'download.link' | translate: descriptionParams}}</a></p>\n      <br /><br />\n      <div *ngIf=\"isIos\">\n        <p><strong translate>download.adviseTitle</strong></p>\n        <p translate>download.adviseText</p>\n    </div>\n    </article>\n  </section>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/download/download.component.html
// module id = ../../../../../src/app/download/download.component.html
// module chunks = main